<div formGroupName="kensakuJyoukenChild">
  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約担当部署</mat-label>
      <mat-select formControlName="keiyakuTantouBushoCategory" (selectionChange)="onChangeSelectBox($event)">
        <mat-option value=""></mat-option>
        <mat-option *ngFor="let keiyakuTantouBusho of keiyakuTantouBushoList" [value]="keiyakuTantouBusho.value">
          {{keiyakuTantouBusho.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class=" tw-flex tw-flex-row tw-flex-wrap justify-between">
      <div class="tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%] tw-ml-[40px]">
        <mat-checkbox
          id="keiyakuTantouCheckBox" formControlName="keiyakuTantouCheckBox"
          (change)="onChangeCheckBox($event.checked)" color="primary"
          class="check-box">
            契約担当者個別入力
        </mat-checkbox>
      </div>
    </div>

    <mat-form-field *ngIf="!keiyakuTantousyaFlg" appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
      <mat-label>契約担当者</mat-label>
      <mat-select formControlName="keiyakuTantousyaCategory">
        <mat-option value=""></mat-option>
        <mat-option *ngFor="let keiyakuTantousya of keiyakuTantousyaList" [value]="keiyakuTantousya.value">
          {{keiyakuTantousya.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="keiyakuTantousyaFlg" appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
      <mat-label>契約担当者</mat-label>
      <input matInput formControlName="keiyakuTantousyaTxt" autocomplete="off" maxlength="40" />
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>包括お客さま番号</mat-label>
      <input matInput formControlName="houkatsuOkyakusamaNo" autocomplete="off" maxlength="10" />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>包括お客さま名</mat-label>
      <input matInput formControlName="houkatsuOkyakusamaName" autocomplete="off" maxlength="50" />
    </mat-form-field>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>申請状況</mat-label>
      <mat-select formControlName="shinseiJoukyouCategory">
        <mat-option value=""></mat-option>
        <mat-option *ngFor="let shinseiJoukyou of shinseiJoukyouList" [value]="shinseiJoukyou.value">
          {{shinseiJoukyou.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約終了日（開始）</mat-label>
      <input matInput [matDatepicker]="keiyakuManryouYMDFrom" formControlName="keiyakuManryouYMDFrom" autocomplete="off"
        maxlength="10" />
      <mat-datepicker-toggle matSuffix [for]="keiyakuManryouYMDFrom"></mat-datepicker-toggle>
      <mat-datepicker #keiyakuManryouYMDFrom></mat-datepicker>
    </mat-form-field>

    <span style="margin-left:40px">～</span>

    <mat-form-field appearance="outline"
      class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label class="mat-label-important">契約終了日（終了）</mat-label>
      <input matInput [matDatepicker]="keiyakuManryouYMDTo" formControlName="keiyakuManryouYMDTo" autocomplete="off"
        maxlength="10" />
      <mat-datepicker-toggle matSuffix [for]="keiyakuManryouYMDTo"></mat-datepicker-toggle>
      <mat-datepicker #keiyakuManryouYMDTo></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-checkbox id="kakokeiyakuCheckBox" formControlName="kakokeiyakuCheckBox"
      class="check-box tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%] tw-ml-[40px]"
      color="primary">過去契約も含む
    </mat-checkbox>
  </div>
</div>

<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
  <mat-card-actions class="btn_area_right">
    <button type="submit" mat-raised-button color="primary"
      [disabled]="parentForm.invalid || kensakuJyoukenChild.invalid" class="btn" (click)="onClickSearch()">
      検索
    </button>
  </mat-card-actions>

  <mat-card-actions class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()">
      クリア
    </button>
  </mat-card-actions>
</div>